





















































import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      nav: true,
    };
  },
  methods: {
    linkPage(page: string) {
      this.nav = false;
      this.$router.push({name: page});
    },
  },
});
